<template>
  <el-scrollbar>
    <el-calendar v-model="date">
      <template slot="dateCell" slot-scope="{ date, data }">
        <label>{{ date.getDate() }}</label>
        <tooltip :rows="getItems(data.day)" />
      </template>
    </el-calendar>
    <div class="total">
      <p>实际投标 共{{ biddata.tbcs }}次</p>
      <p class="text-price text-danger">{{ biddata.zbzj }}</p>
      <p class="describe">
        <label>中标率 {{ biddata.zbl }}%</label>
        <label>折价率 {{ biddata.zjl }}%</label>
      </p>
    </div>
    <el-carousel direction="vertical" :autoplay="false">
      <el-carousel-item v-for="item in modedata" :key="item.mode" class="total">
        <p>{{ item.mode }}投标 {{ item.tbcs }}次</p>
        <el-progress type="dashboard" :percentage="item.ratio || 0" />
        <p class="text-price text-danger" style="font-size: 28px">
          {{ item.zbzj }}
        </p>
        <p class="describe">
          <label>中标率 {{ item.zbl }}%</label>
          <label>折价率 {{ item.zjl }}%</label>
        </p>
      </el-carousel-item>
    </el-carousel>
    <div ref="stateBar" style="width：100%;height:100%;background: #fff;" />
  </el-scrollbar>
</template>

<script>
let echarts = require("echarts");
let elementResizeDetectorMaker = require("element-resize-detector");
export default {
  components: {
    tooltip: () => import("./_tooltip.vue"),
  },
  data() {
    return {
      date: new Date(),
      modeOptions: [],
      queryParams: null,
      datalist: [],
      biddata: {},
      modedata: [],
    };
  },
  created() {
    this.$apis.system.meta.itemList({ typeId: "inquiry-mode" }).then((res) => {
      this.modeOptions = res;
      this.loadData();
    });
  },
  computed: {
    //获取当天的数据
    getItems() {
      return (day) => {
        var rows = this.datalist.filter((row) => row.ExpiryDate == day);
        return rows;
      };
    },
  },
  methods: {
    //加载数据
    loadData() {
      this.$apis.project.inquiry
        .plains(this.queryParams)
        .then((res) => {
          this.datalist = res.map((row) => {
            row.Mode = this.modeOptions.filter(
              (x) => x.Code == row.Mode
            )[0]?.Name;
            row.ExpiryDate = this.$utils.common.parseTime(row.ExpiryDate);
            return row;
          });
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    //汇总投标情况
    getTotal() {
      let tbcs = this.datalist.filter((row) => row.Result != 0).length,
        zbcs = this.datalist.filter((row) => row.Result == 1).length,
        tbzj = this.datalist
          .filter((row) => row.Result == 1)
          .reduce((acc, cur) => {
            return acc + cur.BudgetPrice;
          }, 0),
        zbzj = this.datalist
          .filter((row) => row.Result == 1)
          .reduce((acc, cur) => {
            return acc + cur.FinalPrice;
          }, 0);

      this.biddata = {
        tbcs: tbcs,
        zbzj: zbzj,
        zbl: ((zbcs / tbcs) * 100).toFixed(2),
        zjl: ((zbzj / tbzj) * 100).toFixed(2),
      };
    },

    //分类投标情况
    getModes() {
      this.modedata = this.modeOptions.map((m) => {
        let tbcs =
            this.datalist.filter((row) => row.Mode == m.Name && row.Result != 0)
              .length || 0,
          zbcs =
            this.datalist.filter((row) => row.Mode == m.Name && row.Result == 1)
              .length || 0,
          tbzj = this.datalist
            .filter((row) => row.Mode == m.Name && row.Result == 1)
            .reduce((acc, cur) => {
              return acc + (cur.BudgetPrice || 0);
            }, 0),
          zbzj = this.datalist
            .filter((row) => row.Mode == m.Name && row.Result == 1)
            .reduce((acc, cur) => {
              return acc + (cur.FinalPrice || 0);
            }, 0);

        return {
          mode: m.Name,
          ratio:
            (tbcs / this.datalist.filter((m) => m.Result != 0).length) * 100,
          tbcs: tbcs,
          zbzj: zbzj,
          zbl: ((zbcs / tbcs) * 100).toFixed(2),
          zjl: ((zbzj / tbzj) * 100).toFixed(2),
        };
      });
    },

    //绘制柱状图
    drowChart(data) {
      let xData = [],
        sData = [];
      data.forEach((element) => {
        xData.push(element.text);
        sData.push(element.value);
      });
      let option = {
        grid: {
          top: 20,
          bottom: 30,
          right: 0,
          left: 0,
        },
        xAxis: {
          type: "category",
          data: xData,
        },
        yAxis: {
          type: "log",
          show: false,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        series: [
          {
            data: sData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter: "{c}条",
            },
            showBackground: true,
            barMaxWidth: 50,
            barMinHeight: 20,
            itemStyle: {
              color: function (params) {
                var colorlist = [
                  "#409EFF",
                  "#E67716",
                  "#FBC300",
                  "#67C23A",
                  "#F56C6C",
                ];
                return colorlist[params.dataIndex];
              },
            },
          },
        ],
      };
      const dom = this.$refs.stateBar;
      let chart = echarts.getInstanceByDom(dom);
      if (dom) {
        if (chart == null) {
          chart = echarts.init(dom);
        }
        chart.setOption(option);
        //响应刷新
        elementResizeDetectorMaker().listenTo(dom, function () {
          chart.resize();
        });
      }
    },
  },
  watch: {
    datalist() {
      this.drowChart([
        {
          text: "待截单",
          value: this.datalist.filter((row) => row.State == 0).length,
        },
        {
          text: "报价中",
          value: this.datalist.filter((row) => row.State == 1).length,
        },
        {
          text: "投标中",
          value: this.datalist.filter((row) => row.State == 2).length,
        },
        {
          text: "中标",
          value: this.datalist.filter(
            (row) => row.State == 9 && row.Result == 1
          ).length,
        },
        {
          text: "未中标",
          value: this.datalist.filter(
            (row) => row.State == 9 && row.Result == -1
          ).length,
        },
      ]);
      this.getTotal();
      this.getModes();
    },
    date(n, o) {
      if (n.getFullYear() != o.getFullYear() || n.getMonth() != o.getMonth()) {
        let y = n.getFullYear(),
          m = n.getMonth();
        this.queryParams = {
          startDate: new Date(y, m, 1),
          dueDate: new Date(y, m + 1, 0),
        };
        this.loadData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-scrollbar) {
  border: 1px solid #f00;
  &__view {
    display: grid;
    grid-template-columns: 3fr minmax(250px, 1fr);
    grid-template-rows: 160px 300px minmax(300px, 1fr);
    grid-gap: 16px;
  }
}
:deep(.el-calendar) {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-start: span 3;
  &__body,
  &__header {
    padding: 16px;
  }
  &-table {
    height: 100%;
  }
  &-day {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
  }
}
:deep(.el-carousel) {
  z-index: 1;
  &__button {
    background-color: #409eff;
  }
}
.total {
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  .describe {
    label + label {
      margin-left: 20px;
    }
  }
  .price {
    font-weight: bold;
    font-size: 28px;
    &::before {
      content: unset;
      margin-right: 5px;
    }
    &::after {
      content: "元";
      font-size: 14px;
      margin-left: 5px;
    }
  }
}
</style>